import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { Toaster } from "./components/ui/sonner";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Vendedor from "./pages/Vendedor";
import Travas from "./pages/Travas";
import Hedge from "./pages/Hedge";
import Admin from "./pages/Admin";
import Relatorio from "./pages/Relatorio";
import UsuariosAdmin from "./pages/UsuariosAdmin";
import Ptax from "./pages/Ptax";
import PosicaoDia from "./pages/PosicaoDia";
import ClientesAdmin from "./pages/ClientesAdmin";
import HedgeManual from "./pages/HedgeManual";
import Exposicao from "./pages/Exposicao";
import Charts from "./pages/Charts";
import SpreadSombra from "./pages/SpreadSombra";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#061729]" />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/login" replace />;
  return children;
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#061729]" />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "vendedor") return <Navigate to="/vendedor" replace />;
  if (user.role === "gestao") return <Navigate to="/hedge" replace />;
  return <Navigate to="/hedge" replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/vendedor" element={<Protected roles={["vendedor", "hedge", "admin"]}><Vendedor /></Protected>} />
            <Route path="/vendedor/travas" element={<Protected roles={["vendedor", "admin"]}><Travas /></Protected>} />
            <Route path="/vendedor/ptax" element={<Protected roles={["vendedor", "hedge", "admin", "gestao"]}><Ptax /></Protected>} />
            <Route path="/hedge" element={<Protected roles={["hedge", "admin", "gestao"]}><Hedge /></Protected>} />
            <Route path="/hedge/travas" element={<Protected roles={["hedge", "admin"]}><Travas /></Protected>} />
            <Route path="/hedge/relatorio" element={<Protected roles={["hedge", "admin"]}><Relatorio /></Protected>} />
            <Route path="/hedge/posicao" element={<Protected roles={["hedge", "admin", "gestao"]}><PosicaoDia /></Protected>} />
            <Route path="/hedge/trava-manual" element={<Protected roles={["hedge", "admin", "gestao"]}><HedgeManual /></Protected>} />
            <Route path="/admin/parametros" element={<Protected roles={["hedge", "admin"]}><Admin /></Protected>} />
            <Route path="/admin/usuarios" element={<Protected roles={["admin"]}><UsuariosAdmin /></Protected>} />
            <Route path="/admin/clientes" element={<Protected roles={["admin"]}><ClientesAdmin /></Protected>} />
            <Route path="/hedge/exposicao" element={<Protected roles={["hedge", "admin"]}><Exposicao /></Protected>} />
            <Route path="/charts" element={<Protected roles={["hedge", "admin", "gestao"]}><Charts /></Protected>} />
            <Route path="/hedge/spread-sombra" element={<Protected roles={["admin"]}><SpreadSombra /></Protected>} />

            <Route path="/" element={<RootRedirect />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" theme="dark" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
